require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2004-11-28-your-joking-right-it-doesnt-compile.json") })
        }
      }, "path---articles-2004-11-28-your-joking-right-it-doesnt-compile");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2004-11-28-your-joking-right-it-doesnt-compile!./.cache/json/articles-2004-11-28-your-joking-right-it-doesnt-compile.json
// module id = 369
// module chunks = 231608221292675